var HawkSearch = HawkSearch || {};

HawkSearch.config = {
  clientId: "4d59310fa6b14cc4968b3f8fd139b188",
  search: {
    url: "/search",
    endpointUrl: window.restockitHawkConfig.searchApi,
    itemTypes: {
      default: "product",
    },
    decodeFacetValues: true,
  },
  recommendations: {
    endpointUrl: window.restockitHawkConfig.recommendationsApi,
  },
  tracking: {
    endpointUrl: window.restockitHawkConfig.trackingApi,
  },
  fieldMappings: {
    url: "url_detail",
  },
  components: {
    "landing-page": {
      template: "landing-page__template",
    },
    "search-results": {
      template: "search-results__template",
    },
    "search-results-list": {
      template: "search-results-list__template",
    },
    "search-results-item": {
      template: "search-results-item__template",
    },
    "content-zone": {
      template: "content-zone__template",
    },
    "custom-content": {
      template: "custom-content__template",
    },
    "image-content": {
      template: "image-content__template",
    },
    "modified-query": {
      template: "modified-query__template",
    },
    "query-suggestions": {
      template: "query-suggestions__template",
    },
    "facets-list": {
      template: "facets-list__template",
    },
    "facet-wrapper": {
      template: "facet-wrapper__template",
    },
    autocomplete: {
      template: "autocomplete__template",
    },
    "search-field": {
      strings: {
        placeholder:
          "Search ReStockIt for America's Top Business Supply Brands",
      },
    },
  },
  css: {
    customStyles: "custom-styles__template",
  },
};

let selectedFacetChildren = null;
function navFacetChildren(children) {
  children.forEach(function (child) {
    if (!child.Selected && child.Children.length) {
      navFacetChildren(child.Children);
    } else if (child.Selected && child.Children.length > 0) {
      selectedFacetChildren = child.Children;
      return true;
    }
  });
  return selectedFacetChildren;
}
let facetsMap = {};
let isSearchPage = true;
let isPageContent = false;

// Hawksearch events
addEventListener("hawksearch:after-search-executed", (event) => {
  if (event.detail.RelCanonical) {
    isSearchPage = false;
    facetsMap = event.detail.Facets;
  }

  if (event.detail.PageContent) {
    isPageContent = true;
  }

  const searchResponse = event.detail;

  document.querySelector(".hawksearch__loading")?.classList.add("d-none");

  if (searchResponse.Results?.length < 1 && searchResponse.Keyword !== "") {
    setPageTitle(
      `Search Results: 0 Products match '${searchResponse.Keyword}'`
    );
  }

  if (searchResponse.Pagination && searchResponse.Keyword !== "") {
    if (searchResponse.Pagination.NofResults) {
      setPageTitle(
        `Search Results: ${searchResponse.Pagination.NofResults} Products match '${searchResponse.Keyword}'`
      );
    }
  }
});

addEventListener("hawksearch:initialized", (event) => {
  HawkSearch.handlebars.registerHelper(
    "landingPageCategoryCheck",
    function (title) {
      if (!isSearchPage && title === "Category" && isPageContent) return true;
      return false;
    }
  );

  HawkSearch.handlebars.registerHelper(
    "getLandingPageCategoryMarkup",
    function () {
      facetsMap.forEach(function (facet) {
        if (facet.Name === "Category") {
          facet.Values.forEach(function (facetValue) {
            if (!facetValue.Selected && facetValue.Children.length) {
              navFacetChildren(facetValue.Children);
              return true;
            } else if (facetValue.Selected && facetValue.Children.length) {
              selectedFacetChildren = facetValue.Children;
              return true;
            }
          });
        }
      });
      let html = "";
      selectedFacetChildren?.forEach(function (child) {
        html += `
          <li class="checkbox-list-facet__list__item custom-category-checkbox-container">
            <div class="checkbox-list-facet__list__item__content custom-category-checkbox">
              <a href="${child.URL}">
                <span>
                  ${child.Label}${child.Count > 0 ? ` (${child.Count})` : ""}
                </span>
              </a>
            </div>
          </li>
          `;
      });
      return html;
    }
  );

  HawkSearch.handlebars.registerHelper("slugify", function (value) {
    if (!value) return value;
    return window.App.helpers.slugify(value);
  });

  HawkSearch.handlebars.registerHelper("loginForPrice", function (value) {
    if (!value || value[0] !== "True") return null;
    return "d-none";
  });

  HawkSearch.handlebars.registerHelper("isTrue", function (value) {
    // console.log(value[0])
    if (!value) return false;
    if (value[0] === "True") return true;
    else return false;
  });

  HawkSearch.handlebars.registerHelper("getPageTitle", function () {
    if (sessionStorage.getItem("searched_page_title")) {
      let pageTitle = sessionStorage.getItem("searched_page_title");
      sessionStorage.removeItem("searched_page_title");
      return pageTitle;
    } else {
      return "";
    }
  });

  HawkSearch.handlebars.registerHelper("gtDecimal", function (first, second) {
    if (parseFloat(first?.[0]) > parseFloat(second?.[0])) return true;

    return false;
  });

  HawkSearch.handlebars.registerHelper("toLowerCase", function (str) {
    return str[0]?.toLowerCase();
  });
});

addEventListener("hawksearch:search-completed", (event) => {
  console.log("Hawksearch Page", event.detail);

  // Scroll to top of page
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

  // Breadcrumb Schema Markup
  handleBreadcrumbSchema(event?.detail?.content?.breadcrumbs);

  // Clean Canonical URL
  const canonicalUrlElm = document.querySelector('link[rel="canonical"]');

  if (canonicalUrlElm) {
    const canonicalUrl = canonicalUrlElm.href;

    let cleanCanonical = new URL(canonicalUrl);
    cleanCanonical.search = "";

    const canonicalUrlParams = new URLSearchParams(window.location.search);
    const page = canonicalUrlParams.get("page");
    if (page > 1) {
      cleanCanonical.search = `?page=${page}`;
    }

    cleanCanonical = cleanCanonical
      .toString()
      .replace(
        "https://restockitnew.myshopify.com",
        "https://www.restockit.com"
      )
      .replace(/\/+$/, "") // Remove trailing slash
      .toLowerCase();

    canonicalUrlElm.href = cleanCanonical;
  }
});

addEventListener("hawksearch:after-autocomplete-executed", (event) => {
  const autocompleteResponse = event.detail;
  categoryMap = autocompleteResponse.Categories;
});

addEventListener("hawksearch:autocomplete-completed", (event) => {
  const autocompleteResponse = event.detail;

  if (autocompleteResponse.products?.totalRecords === 1) {
    const product = autocompleteResponse.products.results[0];

    if (autocompleteResponse.query === product.sku) {
      // Remove domain from product url
      const productUrl = product.url.replace(/^[^:]+:\/\/[^/?#]+/, "");
      if (productUrl) window.location.href = productUrl;
    }
  }

  autocompleteResponse.categories.results.forEach(function (category) {
    var catMap = categoryMap.find(
      (element) => element.FieldQSValue === category.value
    );
    if (catMap !== undefined && catMap.Url.startsWith("/")) {
      category.url = catMap.Url;
    }
    let title = category.title.split("^")[0];
    if (title.includes("&raquo;"))
      title = title.substring(title.lastIndexOf("&raquo;") + 7)?.trim();
    category.title = title;
  });
});

// Hawksearch Functions
function setPageTitle(title) {
  sessionStorage.setItem("searched_page_title", title);

  const heading = getShadowElement(".page-heading", "search-results");
  if (!heading) return;
  heading.innerHTML = title;
}

function getShadowElement(selector, component = "search-results-item") {
  let response;
  let selectedShadowRoot;
  let parentShadowRoot = document
    .querySelector("hawksearch-landing-page")
    ?.shadowRoot?.querySelector("hawksearch-search-results")?.shadowRoot;

  if (!parentShadowRoot)
    parentShadowRoot = document.querySelector(
      "hawksearch-search-results"
    )?.shadowRoot;

  if (!parentShadowRoot) {
    console.error("Failed to get parent shadow root");
    return null;
  }

  switch (component) {
    case "search-results":
      selectedShadowRoot = parentShadowRoot;
      break;
    case "search-results-item":
      selectedShadowRoot = parentShadowRoot
        .querySelector("hawksearch-search-results-list")
        .shadowRoot.querySelectorAll("hawksearch-search-results-item");
      break;
  }

  if (!selectedShadowRoot) {
    console.log("No shadow root selected");
    return null;
  }

  if (selectedShadowRoot.constructor === NodeList) {
    selectedShadowRoot.forEach((result) => {
      if (result.shadowRoot.querySelector(selector)) {
        response = result.shadowRoot.querySelector(selector);
      }
    });
  } else {
    response = selectedShadowRoot.querySelector(selector);
  }

  return response;
}

function hawksearchUpdateQuantity(type, productId) {
  const quantityField = getShadowElement(`.fn__quantity--${productId}`);

  switch (type) {
    case "remove":
      if (quantityField.value > 1) quantityField.value--;
      break;
    case "add":
      quantityField.value++;
      break;
  }
}

async function hawksearchAddToCart(id, handle) {
  const quantity = getShadowElement(`.fn__quantity--${id}`)?.value;

  const product = await fetch(
    window.Shopify.routes.root + `products/${handle}.js`
  )
    .then((response) => response.json())
    .catch((error) => console.error(error));

  if (!product) return console.error("No product found");

  const variantId = product.variants[0]?.id;

  if (!variantId) return console.error("No product variant found");

  await window.cart.addItemById(variantId, quantity || 1);

  window.emit("quick-cart:open");
}

function handleBreadcrumbSchema(data) {
  if (!data) return console.log("No breadcrumb data returned from hawksearch");

  try {
    const schemaMarkupScript = document.createElement("script");
    schemaMarkupScript.type = "application/ld+json";

    const breadcrumbList = data.split("&gt;");

    const schemaBreadcrumbs = breadcrumbList.map((crumb, index) => {
      const position = index + 1;
      const isCurrentPage = !crumb.includes("</a>");

      const name = isCurrentPage
        ? crumb.trim() // No a tag as this is the current page, just trim results
        : crumb.replace(/<[^>]+>/g, "").trim(); // Get text from a tag and trim

      // Get href value of 'a' tag
      let item;
      if (!isCurrentPage) {
        item = `https://www.restockit.com${crumb
          .match(/href="([^"]*)/)[0]
          ?.replace('href="', "")}`;
      }

      return {
        "@type": "ListItem",
        position,
        name,
        ...(!isCurrentPage && { item }),
      };
    });

    schemaMarkupScript.innerHTML = `
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": ${JSON.stringify(schemaBreadcrumbs)}
    }`;

    document.head.appendChild(schemaMarkupScript);
  } catch (err) {
    console.error("Failed to generate breadcrumb schema markup", err);
  }
}

function autocompleteCategoryClicked(item, event) {
  let autocompleteTerm =
    document
      .querySelector("hawksearch-search-field")
      .shadowRoot.querySelector("[hawksearch-input]").value ?? "";
  HawkSearch.services.tracking.trackAutocompleteClick(
    autocompleteTerm,
    2,
    item.dataset.title,
    item.dataset.url
  );
}
